import { render, staticRenderFns } from "./employeesList.vue?vue&type=template&id=8dec66bc&scoped=true"
import script from "./employeesList.vue?vue&type=script&lang=js"
export * from "./employeesList.vue?vue&type=script&lang=js"
import style0 from "./employeesList.vue?vue&type=style&index=0&id=8dec66bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec66bc",
  null
  
)

export default component.exports